export const dataCheck = (data, errors = false) => {
  let entitiesError = [];

  const isFloat = (value) => {
    if (
      typeof parseFloat(value) === "number" &&
      !Number.isInteger(parseFloat(value))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const dataChecked = data.entities.filter((entity) => {
    if (entity.latitude && entity.longitude) {
      if (isFloat(entity.latitude) && isFloat(entity.longitude)) {
        if (
          -90 < parseFloat(entity.latitude) &&
          parseFloat(entity.latitude) < 90 &&
          -180 < parseFloat(entity.longitude) &&
          parseFloat(entity.longitude) < 180
        ) {
          return entity;
        } else {
          entitiesError.push({
            name: entity.name,
            error: "latitude range",
            value: entity.latitude,
            reminder: "latitude must be between -90 and 90",
          });
        }
      } else {
        let reminderText = "";

        if (entity.latitude.includes(",")) {
          reminderText = "use a dot not a coma";
        }

        entitiesError.push({
          name: entity.name,
          error: "latitude incorect",
          value: entity.latitude,
          reminder: reminderText,
        });
      }
    } else {
      entitiesError.push({
        name: entity.name,
        error: "lat or long not set",
        value: [entity.latitude, entity.longitude],
      });
    }

    if (errors) {
      console.log("entitiesError", entitiesError);
    }
  });

  return dataChecked;
};
